module.exports = __webpack_public_path__ + "img/SAT_Practice.e33ff779.svg";